import React from 'react';
import { cn } from '../../lib/utils';

export function Button({ children, variant = 'primary', className, ...props }) {
  const baseStyles = "inline-flex items-center justify-center px-4 py-2 font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-brand-red text-white hover:bg-red-800 focus:ring-brand-red",
    secondary: "bg-brand-dark text-white hover:bg-gray-800 focus:ring-brand-dark",
    outline: "border-2 border-brand-red text-brand-red hover:bg-red-50 focus:ring-brand-red",
    ghost: "text-brand-slate hover:text-brand-dark hover:bg-gray-100 focus:ring-gray-200"
  };

  return (
    <button 
      className={cn(baseStyles, variants[variant], className)} 
      {...props}
    >
      {children}
    </button>
  );
}